import { render } from "./CustomerShow.vue?vue&type=template&id=5b111598"
import script from "./CustomerShow.vue?vue&type=script&lang=js"
export * from "./CustomerShow.vue?vue&type=script&lang=js"
script.render = render

export default script